import BaseModel from './BaseModel';
import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';

export default class ResourceCategory extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    margin = undefined,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.margin = margin;
  }

  static get fkName() {
    return 'resource_category_id';
  }
  static get apiRoute() {
    return 'resource_category';
  }
  static get listPageRoute() {
    return 'resourceCategoryList';
  }
  static get detailPageRoute() {
    return 'resourceCategoryList';
  }
  static get createInitColumns() {
    return {};
  }
  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    return config;
  }
  get fkName() {
    return ResourceCategory.fkName;
  }
  get apiRoute() {
    return ResourceCategory.apiRoute;
  }
  get detailPageRoute() {
    return ResourceCategory.detailPageRoute;
  }
  get listPageRoute() {
    return ResourceCategory.listPageRoute;
  }
  get config() {
    return ResourceCategory.config;
  }
  /*static get orderKey() {
    return this.attributeUserLocale('designation', true);
  }*/
  static get orderKeyEmbedded() {
    return 'number';
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'margin',
    ]);
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'margin',
    ];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'margin',
      'forwardToCostResource',
    ]);
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      new AT.DecimalAttribute({
        name: 'margin',
        decimalPrecision: 4,
        creationValue: 1,
        tableProperties: {
          header: 'hit-app.common.margin',
          maxWidth: '0.5fr',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'forwardToCostResource',
        joinPath: [
          'resource!fk_resource_category_cost_forwarding_resource_id_resource',
        ],
        fkToUpdate: 'cost_forwarding_resource_id',
        tableProperties: {
          header: 'hit-app.common.cost-resource',
        },
        filters: {customisable: 'is.true'},
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
